import { render, staticRenderFns } from "./ReportLeads.vue?vue&type=template&id=56b24d95&scoped=true&"
import script from "./ReportLeads.vue?vue&type=script&lang=js&"
export * from "./ReportLeads.vue?vue&type=script&lang=js&"
import style0 from "./ReportLeads.vue?vue&type=style&index=0&id=56b24d95&lang=scss&scoped=true&"
import style1 from "./ReportLeads.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b24d95",
  null
  
)

export default component.exports